import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import TaskAssigneeSelector from "../TaskAssigneeSelector";

export function ControlledTaskAssigneeSelector({
  fieldName,
  defaultValue,
  ...props
}) {
  const { field } = useController({
    name: fieldName,
    defaultValue: defaultValue,
    rules: { required: true },
  });

  return (
    <TaskAssigneeSelector
      {...props}
      initValue={field.value}
      onChange={field.onChange}
    />
  );
}

ControlledTaskAssigneeSelector.propTypes = {
  fieldName: PropTypes.string,
  defaultValue: PropTypes.string,
};

ControlledTaskAssigneeSelector.defaultProps = {
  fieldName: "assigneeId",
  defaultValue: "unassigned",
};

export default ControlledTaskAssigneeSelector;
